import { Field, reduxForm, getFormValues } from 'redux-form';
import React, { Component, Fragment } from 'react';
import { Grid, Form } from 'semantic-ui-react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';

import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { AccuclaimEditReportFieldEnum as Fields } from 'Common/FieldEnum';
import { ACCUCLAIM_EDIT_REPORT_FORM_NAME } from 'Common/FormEnum';
import { DatePickerField } from 'Common/SemanticWrapper';
import { CheckboxField } from 'Common/SemanticWrapper';

class AccuclaimEditFormContainer extends Component {
  feedingOptions = [
    { value: 0, label: 'Breakfast / Lunch / Other' },
    { value: 1, label: 'Supper' },
  ];

  summaryOptions = [
    {
      value: 0,
      label: 'Average',
    },
    {
      value: 1,
      label: 'Sums',
    },
  ];

  render() {
    const { loading, formValues } = this.props;
    return (
      <Fragment>
        <Form name={ACCUCLAIM_EDIT_REPORT_FORM_NAME}>
          <Grid>
            <Grid.Row>
              <Grid.Column width={6} style={{ marginBottom: '35px' }}>
                <ReduxFormButtonGroup
                  label={'Meal Type'}
                  formName={ACCUCLAIM_EDIT_REPORT_FORM_NAME}
                  options={this.feedingOptions}
                  value={formValues[Fields.FeedingType]}
                  fieldName={Fields.FeedingType}
                  disabled={loading}
                />
              </Grid.Column>
              <Grid.Column width={10}>
                <ReduxFormButtonGroup
                  label={'Summary Type'}
                  formName={ACCUCLAIM_EDIT_REPORT_FORM_NAME}
                  options={this.summaryOptions}
                  value={formValues[Fields.SummaryType]}
                  fieldName={Fields.SummaryType}
                  disabled={loading}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ height: '115px' }}>
              <Grid.Column width={4}>
                <Field
                  label={'From Date'}
                  name={Fields.FromDate}
                  component={DatePickerField}
                  type="text"
                  openToDate={moment()}
                  disabled={loading}
                />
              </Grid.Column>
              <Grid.Column width={4}>
                <Field
                  label={'To Date'}
                  name={Fields.ToDate}
                  component={DatePickerField}
                  type="text"
                  openToDate={moment()}
                  disabled={loading}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  label={'Print Original Values'}
                  name={Fields.OmitChanges}
                  component={CheckboxField}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  label={'Print Comments'}
                  name={Fields.PrintComments}
                  component={CheckboxField}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Fragment>
    );
  }
}

const validate = values => {
  const errors = {};

  if (!moment(values[Fields.FromDate]).isValid()) {
    errors[Fields.FromDate] = 'Enter a valid From Date.';
  }
  if (!values[Fields.FromDate]) {
    errors[Fields.FromDate] = 'From Date must be set.';
  }

  if (!moment(values[Fields.ToDate]).isValid()) {
    errors[Fields.ToDate] = 'Enter a valid To Date.';
  }
  if (!values[Fields.ToDate]) {
    errors[Fields.ToDate] = 'To Date must be set.';
  }

  if (
    moment(values[Fields.FromDate]).isValid() &&
    values[Fields.FromDate] &&
    moment(values[Fields.ToDate]).isValid() &&
    values[Fields.ToDate] &&
    moment(values[Fields.ToDate]).isBefore(values[Fields.FromDate])
  ) {
    errors[Fields.ToDate] =
      'To Date must be greater than or equal to From Date.';
  }

  return errors;
};

const mapStateToProps = state => {
  return {
    formValues: getFormValues(ACCUCLAIM_EDIT_REPORT_FORM_NAME)(state),
  };
};

const AccuclaimEditForm = reduxForm({
  form: ACCUCLAIM_EDIT_REPORT_FORM_NAME,
  validate,
  destroyOnUnmount: false,
})(withRouter(connect(mapStateToProps)(AccuclaimEditFormContainer)));

export { AccuclaimEditForm };



// WEBPACK FOOTER //
// ./src/pages/accuclaimedit/components/AccuclaimEditReportForm.js